var map = {
	"./1.svg": "MRlc",
	"./back.svg": "RN8c",
	"./bg.svg": "j7Wo",
	"./breathe1.svg": "WqU6",
	"./ceshi.svg": "dNgG",
	"./k1s.svg": "mcxA",
	"./kv.svg": "Rk2D",
	"./logo.svg": "ZY77",
	"./motion.svg": "sY+L",
	"./wave.svg": "bUWB",
	"./wave2.svg": "fLDC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 1